import React from 'react';
import { X } from 'lucide-react';

const ColumnPicker = ({
                          availableColumns,
                          selectedColumns,
                          onColumnChange,
                          onClose
                      }) => {
    const handleColumnToggle = (column) => {
        const updatedColumns = selectedColumns.includes(column)
            ? selectedColumns.filter(c => c !== column)
            : [...selectedColumns, column];
        onColumnChange(updatedColumns);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 relative z-50">
                <div className="flex justify-between items-center p-4 border-b">
                    <h3 className="text-lg font-semibold">Column Settings</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 transition-colors"
                    >
                        <X size={20} />
                    </button>
                </div>
                <div className="p-4 max-h-[60vh] overflow-y-auto">
                    <div className="space-y-3">
                        {availableColumns.map(column => (
                            <label
                                key={column}
                                className="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 p-2 rounded"
                            >
                                <input
                                    type="checkbox"
                                    checked={selectedColumns.includes(column)}
                                    onChange={() => handleColumnToggle(column)}
                                    className="form-checkbox h-5 w-5 text-blue-600 rounded"
                                />
                                <span className="text-gray-700">
                                    {column.split('.').pop().replace(/([A-Z])/g, ' $1').trim()}
                                </span>
                            </label>
                        ))}
                    </div>
                </div>
                <div className="p-4 border-t flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                    >
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ColumnPicker;